import React from "react";
import TlkTable from "../tlelrik/table/tlkTable";
import services from "../../services";
import moment from "moment";
import $ from "jquery";

let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    Page: 1,
    PageSize: 20,
    idEntidade: null
};

const fullDateFormat = "DD-MM-YYYY HH:mm:ss";

const dateFormat2 = "DD-MM-YYYY";

let tablesjson = {
    
    FiscPendentes: {
        columnkeyMap: {
            numerofisc: "Nº Pedido Fiscalização",
            numeropedido: "Nº Pedido de Origem",
            numeroauto: "Nº Auto",
            estado: "Estado Auto",
            descricao: "Auto",
            localArmazenagem: "Local Armazenagem",
            instalacaoVinica: "Instalação Vínica",
            nome: "Entidade",
            moduloOrigem: "Módulo de Origem",
            edocklink: "Gestão Documental",
            dataCriado: "Data de Submissão",
            criadoPor: "Criado Por",
        },
        actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        listApilink: "Fiscalizacao/GetViewPedidosPendentes",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de fiscalizações pendentes ",
        Filters: {
       
        },
        groupfield: [],
    },
    FiscConcluidos: {
        columnkeyMap: {
            numerofisc: "Nº Pedido Fiscalização",
            numeropedido: "Nº Pedido de Origem",
            numeroauto: "Nº Auto",
            estado: "Estado Auto",
            descricao: "Auto",
            localArmazenagem: "Local Armazenagem",
            instalacaoVinica: "Instalação Vínica",
            nome: "Entidade",
            moduloOrigem: "Módulo de Origem",
            edocklink: "Gestão Documental",
            dataCriado: "Data de Submissão",
            criadoPor: "Criado Por",
        },
        actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf", PdfTooFatura: "Fatura" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        listApilink: "Fiscalizacao/GetViewPedidosConcluidos",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de fiscalizações concluídas ",
        Filters: {
       
        },
        groupfield: [],
    },
    FiscInsercaoSelosEtiquetas: {
        columnkeyMap: {
            tipo: "Tipo",
            numeroSelo: "Nº Selo",
            utilizado: "Utilizado",
            dataUtilizado : "Data Utilizado",
            destruido: "Destruido",
            dataDestruido: "Data Destruido",
            dataEntrega: "Data Entrega"
        },
        actionbuttons: {},
        //actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf", PdfTooFatura: "Fatura" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        listApilink: "Fiscalizacao/ViewSelosEtiquetasSeguranca",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de fiscalizações concluídas ",
        Filters: {
       
        },
        groupfield: [],
    },
    FiscalizacaoRS: {
        columnkeyMap: {
            numerofisc: "Nº Pedido Fiscalização",
            numeroauto: "Nº Auto",
            numeroRequisicao : "Nº Requisição",
            estado: "Estado Auto",
            estadoRequisicao : "Estado Requisição",
            descricao: "Auto",
            localArmazenagem: "Local Armazenagem",
            instalacaoVinica: "Instalação Vínica",
            nome: "Entidade",
            moduloOrigem: "Módulo de Origem",
            edocklink: "Gestão Documental",
            dataCriado: "Data de Submissão",
            criadoPor: "Criado Por",
        },
        actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf" , Desselagem:"Desselagem" , DesbloquearAuto:"DesbloquearAuto"},// Redirect: "Emitir Fatura",
        listApilink: "Fiscalizacao/GetAutosRS",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de Autos com requisição de serviços ",
        Filters: {
       
        },
        groupfield: [],
    },
    FiscalizacaoRequisicaoPrevia: {
        columnkeyMap: {
            numerofisc: "Nº Pedido Fiscalização",
            numeroauto: "Nº Auto",
            numeroRequisicao : "Nº Requisição",
            estado: "Estado Auto",
            estadoRequisicao : "Estado Requisição",
            descricao: "Auto",
            localArmazenagem: "Local Armazenagem",
            instalacaoVinica: "Instalação Vínica",
            nome: "Entidade",
            moduloOrigem: "Módulo de Origem",
            edocklink: "Gestão Documental",
            dataCriado: "Data de Submissão",
            criadoPor: "Criado Por",
        },
        actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        listApilink: "Fiscalizacao/GetAutosRSPrevia",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de Autos com requisição de serviços ",
        Filters: {
       
        },
        groupfield: [],
    },
    
    FiscalizacaoAgendamento: {
        columnkeyMap: {
            numeroRequisicao: "Nr Requisição",
            //servicoTecnico: "Nº Auto",
            finalidade : "Finalidade",
            estado: "Estado",
            dataSubmissao : "Data Submissão",
            produto: "Produto",
            tipoConta: "Tipo Conta",
            dataAtualizacaoEstado: "Data Atualização Estado",
        },
        actionbuttons: {PdfTooAgendamento: "pdf" , AceitarAgendamento: "Aceitar Agendamento"},// Redirect: "Emitir Fatura",
        listApilink: "Fiscalizacao/GetAutosAgendamento",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de Autos com requisição de serviços ",
        Filters: {
       
        },
        groupfield: [],
    },
}


class FiscPendentesTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            error: null,
            showSearchMsg: false,
            totalcount: 0,
            invoice: null
        };
    }

    componentDidMount() {
       
        //console.log("OI");
        this.defaultState();
    }

    componentDidUpdate = (preProp) => {
        if (
            preProp.date !== this.props.date ||
            preProp.tableName !== this.props.tableName
        ) {
         
            this.defaultState();
        }
    };

    defaultState = () => {
        let linkData = { ...tablesjson };
        linkData = tablesjson[this.props.tableName];
        //console.log("OI 2");
        this.setState(
            {
                linkData: linkData,
                tlkState: {
                    take: 20,
                    skip: 0,
                    group: [],
                    exporting: false,
                },
            },
            () => this.getListData()
        );
    };
    
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter };
        
        if (
            Request.Filters.entityId === undefined ||
            Request.Filters.entityId === ""
        ) {
            Request.Filters.entityId = null;
        }
        if (
            Request.Filters.entityname === undefined ||
            Request.Filters.entityname === ""
        ) {
            Request.Filters.entityname = null;
        }
        if(this.props.tableName === "FiscInsercaoSelosEtiquetas"){
           
           Request.idEntidade = Request.Filters.entityIdFilter
            
        }
        return Request;
    };

    getListData = async () => {
        try {
            //console.log("OI 3");
            if (!this.state.linkData) return;
            //console.log("OI 4");
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,
                });
            }
            
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            console.log("columnkeyMap -> ", columnkeyMap);
            console.log("Object.keys(columnkeyMap) -> ", Object.keys(columnkeyMap));
            let res = {};
            //console.log("MOVS PENDENTES");
            //console.log(link);
            //console.log(Request);
            //console.log(method);
            res = await services.apiCall.requestApi(link, Request, method);
            //console.log("ressspnseeeee", res);
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    Object.keys(columnkeyMap).map(function (key) {
                        //console.log(_row, "ROWS Fisc")
                        // if (key === "incorporado") {
                        //     _row[columnkeyMap[key]] = _row.seloIncorporado;
                        // }
                        // // else if(key === 'estado'){
                        // //     _row['Estado'] = _row.codEstado ? 'Ativo' : 'Inativo'
                        // // }
                        // else if (key === "estado") {
                        //     _row["Estado"] = _row.estado;
                        // } else if (key === "mercado") {
                        //     _row[columnkeyMap[key]] = _row.marcadoEspecifico;
                        // }
                        // // else if (key === "idRegisto") {
                        // //     _row[columnkeyMap[key]] = _row.codProcesso // change this key with given key in rotulo doc
                        // // }
                        // else if (key === "descrição") {
                        //     _row[columnkeyMap[key]] =
                        //         _row.rotulo;
                        // } else if (key === "entidade") {
                        //     _row[columnkeyMap[key]] = _row.entidade;
                        // }
                        if (key === "dataCriado") {
                            _row[columnkeyMap[key]] = _row.dataCriado
                                ? moment(_row.dataCriado).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        }else if (key === "dataEntrega") {
                            _row[key] = _row.dataEntrega
                                ? moment(_row.dataEntrega).format(
                                    dateFormat2
                                  )
                                : "nd";
                        }else if(key == "dataSubmissao"){
                            _row[columnkeyMap[key]] = _row.dataSubmissao
                            ? moment(_row.dataSubmissao).format(
                                dateFormat2
                              )
                            : "";
                        }else if(key =="dataAtualizacaoEstado"){
                            _row[columnkeyMap[key]] = _row.dataAtualizacaoEstado
                            ? moment(_row.dataAtualizacaoEstado).format(
                                dateFormat2
                              )
                            : "";
                        } else if (key === "dataDestruido") {
                            _row[columnkeyMap[key]] = _row.dataDestruido
                                ? moment(_row.dataDestruido).format(
                                    dateFormat2
                                  )
                                : "";
                        }else if (key === "dataUtilizado") {
                            _row[columnkeyMap[key]] = _row.dataUtilizado
                                ? moment(_row.dataUtilizado).format(
                                    dateFormat2
                                  )
                                : "";
                        } else{
                            _row[columnkeyMap[key]] = _row[key] || "";
                        }
                       
                     
                        // // else if (key === "idEntidade") {
                        // //     _row[columnkeyMap[key]] = _row.nome // change this key with given key in rotulo doc
                        // // }
                        // else if (key === "tipo_de_processo") {
                        //     _row[columnkeyMap[key]] = _row.descricaos;
                        // }else if (key === "quantidade") {
                        //     _row[columnkeyMap[key]] = services.money.format(_row.quantidade);
                        // } else if (key === "n_de_correlativo") {
                        //     _row[columnkeyMap[key]] = _row.descricaos; // value for this should change after clearification of exact key
                        // } else if (key === "n processo") {
                        //     _row[columnkeyMap[key]] = _row.submetidoPor || "nd";
                        // } else if (key === "registo") {
                        //     _row[columnkeyMap[key]] = _row.numeroRegisto;
                        // } else if (key === "submissão") {
                        //     _row[columnkeyMap[key]] = _row.dataSubmissaoPedido
                        //         ? moment(_row.dataSubmissaoPedido).format(
                        //             dateFormat
                        //           )
                        //         : "nd";
                        // } else if (key === "ultima_verificação") {
                        //     // _row[columnkeyMap[key]] = _row.dataModificado || _row.dataCriado ? moment( _row.dataModificado || _row.dataCriado ).format(fullDateFormat) : "nd";
                        //     _row[columnkeyMap[key]] = _row.evaluation2ReviewDate || _row.lastModifiedOn ? moment(_row.evaluation2ReviewDate || _row.lastModifiedOn).format(dateFormat) : "nd";
                        // } else
                        
                        
                    });
                });
                // console.log("Akash", "1", res);
                window.localStorage.setItem('table_total', res.length);
                this.setState(
                    {
                        data: res,
                        filterData: res,
                        showSearchMsg: false,
                        totalcount: window.localStorage.getItem("table_total"),
                    },
                    () => {
                        // console.log("Akash", "2");
                        this.createTabel();
                    }
                );
            } else {
                this.setState({
                    showSearchMsg: true,
                    totalcount: 0,
                    telkikTable: null,
                });
            }
        } catch (error) {
            this.setState({ error });
        }
    };

    createTabel = () => {
        // console.log("Akash", "3");
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = { ...this.state.linkData.columnkeyMap };
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: "checkbox" };
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            // console.log("actionbuttons", actionbuttons);
            // console.log("filterData", this.state.filterData);

            let telkikTable = (
                <TlkTable
                    date={new Date()}
                    list={this.state.filterData}
                    modulename={this.state.linkData.modulename || "fordefault"}
                    columnlist={columnlist}
                    actionbuttons={actionbuttons}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                    groupfield={this.state.linkData.groupfield}
                />

                // <TlkTable
                //     pdfTitle={this.props.title}
                //     date={new Date()}
                //     // generateDocument={this.state.findnonDocumentedRow === 0 ? null : this.state.linkData.generateDocument}
                //     noDownloadButton={this.state.linkData.noDownloadButton}
                //     // DocumentGERFIP={this.state.linkData.DocumentGERFIP}
                //     actionColumnName={this.state.linkData.actionColumnName}
                //     groupfield={this.state.linkData.groupfield}
                //     modulename={this.state.linkData.modulename || "fordefault"}
                //     notAction={this.state.linkData.notAction}
                //     tlkState={this.state.tlkState}
                //     deleteFunc={(id) => this.props.handleDelete(id)}
                //     tableFilters={(filter) => this.tableFilters(filter)}
                //     list={this.state.filterData}
                //     actionbuttons={actionbuttons}
                //     MainModule="Rotulo"
                //     columnlist={columnlist}
                //     ActionPerform={(action, id) => this.ActionPerform(action, id)}
                // />
            );
            this.setState({
                telkikTable: telkikTable,
            });
        }
    };

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        // console.log("tlfilter",tlfilter);
        try {
            
            let tlkState = { ...tlfilter };
            
            let linkData = { ...this.state.linkData };

            // linkData.Filters = data.Filters
            this.setState(
                {
                    tlkState,
                    linkData,
                },
                () => this.getListData()
            );
        } catch (error) {
            this.setState({ error: error });
        }
        // return data;
    };

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (
            tlkfilter.filter &&
            tlkfilter.filter.filters &&
            tlkfilter.filter.filters.length > 0
        ) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value = _srow.value ? _srow.value : "";
                        checkamount = _srow.value.split(" ");
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value)
                            ? Number(_srow.value)
                            : _srow.value;
                        tkkeyvalues.push(_srow.value);
                    });
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            });
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip
            ? tlkfilter.skip / tlkfilter.take + 1
            : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC =
                tlkfilter.sort[0].dir === "asc" ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        //console.log("action perform")
        if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row)
        } else {
        }
        //console.log(row , ".......ENCONTRAR IDAUTO")

        if(action === "PdfToo"){
            (async () => {
               var Detalhes = row.pdf

                this.setState({ invoice: Detalhes });

                var file = this.b64toBlob(Detalhes, 'application/pdf');
                //If the browser is IE or Edge
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file);
                }
                else {
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }
            })();

           
        }
        else if(action === "PdfTooFatura"){
            (async () => {
               var Detalhes = row.pdfFatura

                this.setState({ invoice: Detalhes });

                var file = this.b64toBlob(Detalhes, 'application/pdf');
                //If the browser is IE or Edge
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file);
                }
                else {
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }
            })();

           
        }else if(action == "PdfTooAgendamento"){
            (async () => {
                var Detalhes = row.comprovativoPDF
 
                 this.setState({ invoice: Detalhes });
 
                 var file = this.b64toBlob(Detalhes, 'application/pdf');
                 //If the browser is IE or Edge
                 if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                     window.navigator.msSaveOrOpenBlob(file);
                 }
                 else {
                     var fileURL = URL.createObjectURL(file);
                     window.open(fileURL);
                 }
             })();
        }else if(action == "AceitarAgendamento"){
            this.AceitarAgendamento(row);
        }else if(action === "DesbloquearAuto"){
            this.handleDesbloquear(row)

        }else if(action === "Desselagem"){
            window.location.href = `/inserirFiscalizacao?&idAuto=${row.detalheURLIdAuto}&codEstado=${row.detalheURLCodEstado}&Desselagem=true`
        }else{
            window.location.href = `/inserirFiscalizacao?&idAuto=${row.detalheURLIdAuto}&codEstado=${row.detalheURLCodEstado}`
        }
        
    };
    handleDesbloquear = async (row) => { 
        console.log(row)
        let data = {
            idAuto : row.idAuto

        };
        console.log(data , "dados no submit")
        let res = await services.apiCall.requestApi(
            "Fiscalizacao/DesbloquearRS",
            data,
            "post"
        );
    };

    AceitarAgendamento = async (row) => { 
        console.log(row)
        let data = {
            idRequisicaoServicos : row.idRequisicaoServicos

        };
        console.log(data , "dados no submit")
        let res = await services.apiCall.requestApi(
            "Fiscalizacao/AceitarAgendamento",
            data,
            "post"
        );
    };
    
    b64toBlob(b64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 0;
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
  }
  
    // selectionChange(selection) {
    //     const data = [...this.state.data].map((item) => {
    //         if (
    //             selection.dataItem.codInstalacaoVinica ===
    //             item.codInstalacaoVinica
    //         ) {
    //             // TODO: Ask @Dart for the unique key to use here
    //             return { ...item, selected: true };
    //         } else {
    //             return { ...item, selected: false };
    //         }
    //     });
    //     this.setState({ data }, async () => {
    //         const queryParams = queryString.stringify({
    //             ...queryString.parse(this.props.location.search),
    //             installationId: 0,
    //         });
    //         this.props.history.push(
    //             `/conta_corrente/accounts_view?${queryParams}`
    //         );
    //     });
    // }

    

    render() {
        return (
            <div className="custom-k-grid table-section">
                <div className="table-responsive">
                    {this.state.telkikTable && (
                        <>
                            <h3>
                                {tablesjson[this.props.tableName] &&
                                tablesjson[this.props.tableName]
                                    .totalPageHeading
                                    ? tablesjson[this.props.tableName]
                                          .totalPageHeading +
                                      "(" +
                                      this.state.totalcount +
                                      ")"
                                    : `A pesquisa retornou ${this.state.totalcount} registos`}
                            </h3>
                            {this.state.telkikTable}
                        </>
                    )}
                    {this.state.totalcount === 0 && (
                        <div className="searct-found">
                            <img className="img-fluid" src="imgs/data-rotulos.png" alt="Não foram identificados registos com os critérios indicados" />
                            {this.state.showSearchMsg ? (
                                <p className="font-14">Não foram identificados registos com os critérios indicados</p>
                            ) : (
                                <h3>
                                    Pesquise uma instalação ou entidade para
                                    apresentação de mais informações
                                </h3>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default FiscPendentesTab;
